<template>
    <div class="wrap">
        <StatusLamp />
        <span
          class="version-name"
          :class="isBold"
        >
          {{ versionLabel }}
        </span>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import StatusLamp from './status_lamp'

export default {
  components: { StatusLamp },

  computed: {
    ...mapGetters('knowledgebase/versions', ['versionLabel']),

    isBold () {
      return (this.versionLabel === 'Edited' || this.versionLabel === 'New') ? 'bold' : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
    display: flex;
    align-items: center;
    padding: 0 8px;

    .version-name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: $or-black-blue;
      font-size: 12px;
      line-height: 18px;

      &.bold {
        font-weight: bold;
      }
    }
  }
</style>
